import React, { memo } from 'react';
import { ReactComponent as DiscoverIcon } from '../icons/discover-icon.svg';
import { ReactComponent as SettingsIcon } from '../icons/settings-icon.svg';

const HeroContent = memo(() => {
  return (
    <section className='lg:min-h-[80vh] 2xl:min-h-[50vh] pb-16'>
      <div className="flex-1 flex flex-col xl:grid grid-cols-[1.2fr_0.8fr] lg:items-end items-start lg:gap-0 gap-8">
        <div className="h-full justify-stretch flex flex-col gap-12">
          <div className="">
            <p className="text-4xl xl:text-6xl text-white font-medium" style={{ lineHeight: '150%' }}>
              Find the{" "}
              <span className="text-highlight font-mynerve text-5xl/10 xl:text-7xl/10 font-medium">
                perfect venue
              </span>
              {" "}for your next event without the legwork
            </p>
          </div>
          <div className='flex lg:flex-row flex-col gap-6'>
            <div className='flex flex-col gap-6'>
              <div className="flex items-center space-x-4">
                <DiscoverIcon width={32} height={32} className="flex-shrink-0 mt-1" />
                <p className="text-white text-lg leading-relaxed">
                  Discover unique pubs, cosy cafes, and inspiring co-working spaces.
                </p>
              </div>
              <div className="flex items-center space-x-4">
                <SettingsIcon width={32} height={32} className="flex-shrink-0 mt-1" />
                <p className="text-white text-lg leading-relaxed">
                  Compare, book, and manage your event all in one place
                </p>
              </div>
            </div>
            <div className="hidden lg:block xl:hidden">
              <div className='lg:w-[600px] lg:h-[400px] w-full h-full'>
                <img src="/hero.png" alt="Illustration" className="h-full w-full object-contain" />
              </div>
            </div>
          </div>
        </div>

        <div className="hidden xl:block flex justify-center w-[600px] h-[400px]" >
          <img src="/hero.png" alt="Illustration" className="h-full w-full object-contain" />
        </div>
      </div>
    </section>
  );
});

HeroContent.displayName = 'HeroContent';

export default HeroContent;